"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _dataQuery = require("@/api/dataQuery");
var _default = exports.default = {
  data: function data() {
    var _this2 = this;
    return {
      loading: false,
      colors: ["#3e89e7", "#fb8c3b", "#63be65", "#d9c32b", "#e11aed", "#26c9e7", "#25c1a9", "#1665D8", "#dd3710", "#48a221", "#ffac30", "#75deff", "#8656ff", "#98FF25", "#FFF100", "#ee2dff", "#2deeff", "#ffac2a", "#91c7ae", "#749f83", "#ca8622", "#bda29a", "#6e7074", "#546570", "#c4ccd3"],
      form: {
        startTime: "",
        endTime: "",
        cycleType: 1,
        timeType: 1,
        projectId: this.$store.state.project.projectInfo.id,
        projectFieldIds: []
      },
      userInfo: {},
      energyForm: {
        isShow: 1,
        isTimeShow: 1,
        timeData: [],
        projectSystemDeviceValue: [],
        projectFieldInfoValue: [],
        projectSystemValue: []
      },
      energyOneForm: {
        projectSystemDeviceValue: [],
        projectFieldInfoValue: [],
        projectSystemValue: []
      },
      projectSystemData: [],
      projectSystemDeviceData: [],
      projectFieldInfoData: [],
      historicalData: [],
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      iscred: 1,
      colorType: "",
      echartfc: "",
      // 图表颜色
      treedata: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      // 第一次进入页面的默认展开项
      defaultChecked: [],
      dateListTime: [{
        name: this.$t('all.zjst'),
        id: 1
      }, {
        name: this.$t('all.zjyz'),
        id: 2
      }, {
        name: this.$t('all.zjyy'),
        id: 3
      }],
      dateListDay: [{
        name: this.$t('all.zjyz'),
        id: 1
      }, {
        name: this.$t('all.zjyy'),
        id: 2
      }, {
        name: this.$t('all.zjsy'),
        id: 3
      }],
      dateListMonth: [{
        name: this.$t('all.zjly'),
        id: 4
      }, {
        name: this.$t('all.zjyn'),
        id: 5
      }, {
        name: this.$t('all.zjsn'),
        id: 6
      }],
      dateList3: [{
        name: this.$t('all.hour'),
        id: 1
      }, {
        name: this.$t('all.day'),
        id: 2
      }, {
        name: this.$t('all.month'),
        id: 3
      }],
      // 时 日
      startDate: '',
      endDate: '',
      startDatePicker: {
        //禁用的日期
        disabledDate: function disabledDate(time) {
          //如果已经已知结束日期，就把结束日期之后的日期禁用
          if (_this2.endDate) {
            return time.getTime() > new Date(_this2.endDate).getTime();
          } else {
            //否则 就把当前日期之后的日期禁用掉
            return time.getTime() > Date.now();
          }
        }
      },
      endDatePicker: {
        disabledDate: function disabledDate(time) {
          //如果已知开始日期，就把开始日期之前的日期禁用掉
          if (_this2.startDate) {
            return time.getTime() < new Date(_this2.startDate).getTime() - 1 * 24 * 60 * 60 * 1000;
          }
        }
      },
      // 月
      startDateMonth: '',
      endDateMonth: '',
      startDateMonthPicker: {
        //禁用的日期
        disabledDate: function disabledDate(time) {
          //如果已经已知结束日期，就把结束日期之后的日期禁用
          if (_this2.endDateMonth) {
            return time.getTime() > new Date(_this2.endDateMonth).getTime();
          } else {
            //否则 就把当前日期之后的日期禁用掉
            return time.getTime() > Date.now();
          }
        }
      },
      endDateMonthPicker: {
        disabledDate: function disabledDate(time) {
          //如果已知开始日期，就把开始日期之前的日期禁用掉
          if (_this2.startDateMonth) {
            return time.getTime() < new Date(_this2.startDateMonth).getTime();
          }
        }
      },
      allEnergyTreeChildrenIds: [],
      variableHeight: '',
      zoom: '',
      zoomrAtio: ''
    };
  },
  watch: {
    "energyForm.isTimeShow": function energyFormIsTimeShow(val) {
      this.timeData = [];
      if (val === 3) {
        this.energyForm.isShow = 4;
      } else {
        this.energyForm.isShow = 1;
      }
      this.energyForm.isTimeShow = val;
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
    },
    "energyForm.isShow": function energyFormIsShow(val) {
      this.energyForm.timeData = [];
      this.energyForm.isShow = val;
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
    },
    "$store.state.project.colorType": function $storeStateProjectColorType() {
      this.colorType = this.$store.state.project.colorType;
      if (this.colorType == 'theme_jyh') {
        this.echartfc = '#fff';
      } else if (this.colorType == 'theme_ytl') {
        this.echartfc = '#333';
      } else {
        this.echartfc = '#333';
      }
      this.getLineCharts();
    }
  },
  mounted: function mounted() {
    this.colorType = this.$store.state.project.colorType;
    if (this.colorType == 'theme_jyh') {
      this.echartfc = '#fff';
    } else if (this.colorType == 'theme_ytl') {
      this.echartfc = '#333';
    } else {
      this.echartfc = '#333';
    }
    this.iscred = 2;
    this.getProjectSystemData();
    this.energyDefaultParams();
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    this.getHeight();
  },
  methods: {
    getHeight: function getHeight() {
      var height = window.screen.height * window.devicePixelRatio;
      if (height >= 2160) {
        this.variableHeight = 'vh1';
      } else if (height >= 1800) {
        this.variableHeight = 'vh2';
      } else if (height >= 1600) {
        this.variableHeight = 'vh3';
      } else if (height >= 1440) {
        this.variableHeight = 'vh4';
      } else if (height >= 1000) {
        this.variableHeight = '';
      } else if (height >= 800) {
        this.variableHeight = 'vh6';
      } else if (height >= 700) {
        this.variableHeight = 'vh5';
      } else {
        this.variableHeight = '';
      }
    },
    handleStartTime: function handleStartTime(val) {
      this.energyForm.isShow = 0;
      this.form.startTime = val;
    },
    handleEndTime: function handleEndTime(val) {
      this.energyForm.isShow = 0;
      this.form.endTime = val;
    },
    handelTime1: function handelTime1(val) {
      this.energyForm.isShow = val;
      this.startDate = '';
      this.endDate = '';
      this.startDateMonth = '';
      this.endDateMonth = '';
      this.form.startTime = '';
      this.form.endTime = '';
    },
    handelTime2: function handelTime2(val) {
      this.energyForm.isShow = val;
      this.startDate = '';
      this.endDate = '';
      this.startDateMonth = '';
      this.endDateMonth = '';
      this.form.startTime = '';
      this.form.endTime = '';
    },
    handelDay: function handelDay(val) {
      this.energyForm.isShow = val;
      this.startDate = '';
      this.endDate = '';
      this.startDateMonth = '';
      this.endDateMonth = '';
      this.form.startTime = '';
      this.form.endTime = '';
    },
    handelTime3: function handelTime3(val) {
      this.energyForm.isTimeShow = val;
      this.startDate = '';
      this.endDate = '';
      this.startDateMonth = '';
      this.endDateMonth = '';
      this.form.startTime = '';
      this.form.endTime = '';
    },
    // 获取所有子类id
    getAllTreeIds: function getAllTreeIds(val) {
      var _this3 = this;
      val.forEach(function (item) {
        if (item.children && item.children.length) {
          _this3.getAllTreeIds(item.children);
        } else {
          _this3.allEnergyTreeChildrenIds.push(item.id);
        }
      });
    },
    // 查询所有树状结构
    getProjectSystemAllList: function getProjectSystemAllList() {
      var _this4 = this;
      var params = {
        projectId: this.$store.state.project.projectInfo.id
      };
      (0, _dataQuery.projectAllFieldInfoByEnergySystem)(params).then(function (res) {
        // 获取树状结构
        _this4.getAllTreeIds(res);
        localStorage.setItem('allEnergyTreeChildrenIds', _this4.allEnergyTreeChildrenIds);
        _this4.treedata = res;
        _this4.sortTreeData(_this4.treedata);
        // 如果第一次进来就用接口默认的 如果他自己选了就用缓存的 
        if (localStorage.getItem('energyAllCheckedIds')) {
          // 先获取缓存里面的数据
          _this4.defaultChecked = localStorage.getItem('energyAllCheckedIds').split(',');
          // 还要判断是否用了别的项目的缓存
          if (_this4.defaultChecked.some(function (item) {
            return _this4.allEnergyTreeChildrenIds.includes(item * 1);
          })) {
            _this4.$nextTick(function () {
              _this4.$refs.tree.setCheckedKeys([]);
              _this4.defaultChecked = localStorage.getItem('energyAllCheckedIds').split(',');
            });
          } else {
            _this4.defaultChecked = _this4.form.projectFieldIds;
            localStorage.setItem('energyAllCheckedIds', _this4.defaultChecked);
          }
        } else {
          _this4.defaultChecked = _this4.form.projectFieldIds;
        }
        _this4.getDataStatisticsData();
      }).catch(function (err) {
        console.log(err);
      });
    },
    sortTreeData: function sortTreeData(arr) {
      var _this5 = this;
      if (arr && arr.length && arr != undefined) {
        //排序当前数据
        this.sortByNationality(arr);
        //递归排序子目录
        arr.forEach(function (item) {
          if (item.children && item.children.length) {
            _this5.sortTreeData(item.children);
          }
        });
      }
      return;
    },
    sortByNationality: function sortByNationality(arr) {
      // 首先将数组按照字典序进行排序  
      arr.sort(function (a, b) {
        var aName = a.name.toUpperCase();
        var bName = b.name.toUpperCase();
        return aName.localeCompare(bName, "zh");
      });
      return arr;
    },
    // 监听他选中的项
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      this.form.projectFieldIds = this.$refs.tree.getCheckedKeys();
      // 选中id当做缓存
      localStorage.setItem('energyAllCheckedIds', this.form.projectFieldIds);
    },
    //能耗查询默认参数
    energyDefaultParams: function energyDefaultParams() {
      var _this6 = this;
      var ts = this;
      var par = {
        projectId: ts.$store.state.project.projectInfo.id
      };
      (0, _dataQuery.energyDefaultParams)(par).then(function (res) {
        ts.form.startTime = res.startTime;
        ts.form.endTime = res.endTime;
        ts.form.cycleType = res.cycleType;
        ts.form.timeType = res.timeType;
        if (res.projectFieldIds && res.projectFieldIds.length > 0) {
          res.projectFieldIds.forEach(function (item) {
            ts.form.projectFieldIds.push(item);
          });
        }
        // 页面加载初始化树状结构
        ts.getProjectSystemAllList();
        ts.energyForm.isTimeShow = res.cycleType;
        ts.energyForm.isShow = res.timeType;
        ts.energyOneForm.projectSystemValue.push(res.projectSystemDeviceId);
        ts.energyOneForm.projectSystemDeviceValue.push(res.equipmentId);
        ts.energyOneForm.projectFieldInfoValue = res.projectFieldIds;
        if (res.startTime && res.endTime) {
          ts.energyForm.timeData.push(res.startTime);
          ts.energyForm.timeData.push(res.endTime);
        }
        _this6.getProjectSystemDeviceData(res.projectSystemDeviceId);
        _this6.getProjectFieldInfoData(res.equipmentId);
      });
    },
    handleDown: function handleDown() {
      if (this.form.projectFieldIds.length === 0) {
        this.$message.warning("请选择字段名称");
      } else {
        this.getHistoricalDatExportData();
      }
    },
    // 中文排序
    paramsSort: function paramsSort(data, params) {
      return data.sort(function (a, b) {
        return a[params].localeCompare(b[params], "zh");
      });
    },
    handleTime: function handleTime(val) {
      var _this7 = this;
      this.energyForm.isShow = 0;
      this.$nextTick(function () {
        _this7.energyForm.timeData = Object.assign([], (0, _toConsumableArray2.default)(val));
      });
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
      this.form.startTime = val[0];
      this.form.endTime = val[1];
    },
    handleProjectSystem: function handleProjectSystem(val) {
      this.iscred = 1;
      if (val.length === 0) {
        this.projectFieldInfoData = [];
        this.form.projectFieldIds = [];
        this.projectSystemDeviceData = [];
      } else {
        if (val.indexOf("all") !== -1) {
          this.energyForm.projectSystemValue = this.projectSystemData.map(function (e) {
            return e.projectSystemId;
          });
        } else {
          this.energyForm.projectSystemValue = val;
        }
        this.getProjectSystemDeviceData(this.energyForm.projectSystemValue);
      }
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
    },
    handleProjectSystemDevice: function handleProjectSystemDevice(val) {
      this.iscred = 1;
      if (val.length === 0) {
        this.projectFieldInfoData = [];
        this.form.projectFieldIds = [];
        this.energyForm.projectFieldInfoValue = [];
        this.energyOneForm.projectFieldInfoValue = [];
      } else {
        if (val.indexOf("all") !== -1) {
          this.energyForm.projectSystemDeviceValue = this.projectSystemDeviceData.map(function (e) {
            return e.projectSystemDeviceId;
          });
        } else {
          this.energyForm.projectSystemDeviceValue = val;
        }
        this.getProjectFieldInfoData(this.energyForm.projectSystemDeviceValue);
      }
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
    },
    handleProjectField: function handleProjectField(val) {
      this.iscred = 1;
      if (val.indexOf("all") !== -1) {
        this.form.projectFieldIds = this.projectFieldInfoData.map(function (e) {
          return e.id;
        });
        this.energyForm.projectFieldInfoValue = this.form.projectFieldIds;
      } else {
        this.form.projectFieldIds = val;
        this.energyForm.projectFieldInfoValue = val;
      }
      sessionStorage.setItem("energyForm", JSON.stringify(this.energyForm));
    },
    getProjectFieldInfoData: function () {
      var _getProjectFieldInfoData = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(val) {
        var _this8 = this;
        var params, res, arr, _loop, i;
        return _regenerator.default.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                systemDeviceIds: val
              };
              _context2.next = 3;
              return (0, _dataQuery.getProjectFieldInfoEnergy)(params);
            case 3:
              res = _context2.sent;
              this.projectFieldInfoData = this.paramsSort(res, "fieldMeaning");
              arr = [];
              _loop = /*#__PURE__*/_regenerator.default.mark(function _loop(i) {
                return _regenerator.default.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _this8.projectFieldInfoData.map(function (e) {
                        if (_this8.form.projectFieldIds[i] === e.id) {
                          arr.push(e.id);
                        }
                      });
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 8:
              if (!(i < this.form.projectFieldIds.length)) {
                _context2.next = 13;
                break;
              }
              return _context2.delegateYield(_loop(i), "t0", 10);
            case 10:
              i++;
              _context2.next = 8;
              break;
            case 13:
              if (this.iscred != 2) {
                this.form.projectFieldIds = arr;
                this.energyForm.projectFieldInfoValue = arr;
                this.energyOneForm.projectFieldInfoValue = arr;
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function getProjectFieldInfoData(_x) {
        return _getProjectFieldInfoData.apply(this, arguments);
      }
      return getProjectFieldInfoData;
    }(),
    getProjectSystemDeviceData: function () {
      var _getProjectSystemDeviceData = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(val) {
        var _this9 = this;
        var params, res, arr, _loop2, i;
        return _regenerator.default.wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = {
                projectSystemIds: val
              };
              _context4.next = 3;
              return (0, _dataQuery.getProjectEnergySystemDevice)(params);
            case 3:
              res = _context4.sent;
              this.projectSystemDeviceData = this.paramsSort(res, "systemDeviceName");
              arr = [];
              _loop2 = /*#__PURE__*/_regenerator.default.mark(function _loop2(i) {
                return _regenerator.default.wrap(function _loop2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _this9.projectSystemDeviceData.map(function (e) {
                        if (_this9.energyForm.projectSystemDeviceValue[i] === e.projectSystemDeviceId) {
                          arr.push(e.projectSystemDeviceId);
                        }
                      });
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop2);
              });
              i = 0;
            case 8:
              if (!(i < this.energyForm.projectSystemDeviceValue.length)) {
                _context4.next = 13;
                break;
              }
              return _context4.delegateYield(_loop2(i), "t0", 10);
            case 10:
              i++;
              _context4.next = 8;
              break;
            case 13:
              if (this.iscred != 2) {
                this.energyForm.projectSystemDeviceValue = arr;
                this.energyOneForm.projectSystemDeviceValue = arr;
                this.getProjectFieldInfoData(this.energyForm.projectSystemDeviceValue);
              }
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this);
      }));
      function getProjectSystemDeviceData(_x2) {
        return _getProjectSystemDeviceData.apply(this, arguments);
      }
      return getProjectSystemDeviceData;
    }(),
    // 获取子类id
    getChildrenId: function getChildrenId(arr) {
      var _this10 = this;
      var tempChildrenId = [];
      // 先判断是否第一次进来，第一次进来没有缓存
      if (localStorage.getItem('energyAllCheckedIds')) {
        if (localStorage.getItem('allEnergyTreeChildrenIds')) {
          this.allEnergyTreeChildrenIds = localStorage.getItem('allEnergyTreeChildrenIds').split(',');
        }
        arr.forEach(function (item) {
          if (_this10.allEnergyTreeChildrenIds.includes(item)) {
            tempChildrenId.push(item);
          }
        });
      } else {
        tempChildrenId = arr;
      }
      return tempChildrenId;
    },
    getDataStatisticsData: function getDataStatisticsData() {
      var _this11 = this;
      this.loading = true;
      this.form.timeType = this.energyForm.isShow;
      this.form.cycleType = this.energyForm.isTimeShow;
      if (localStorage.getItem('energyAllCheckedIds')) {
        this.form.projectFieldIds = localStorage.getItem('energyAllCheckedIds').split(',');
      }
      this.form.projectFieldIds = this.getChildrenId(this.form.projectFieldIds);
      setTimeout(function () {
        _this11.loading = false;
      }, 2000);
      (0, _dataQuery.getEnergyConsumptionQuery)(this.form).then(function (res) {
        _this11.historicalData = res || [];
        _this11.getLineCharts();
        _this11.loading = false;
      });
    },
    getProjectFieldInfoDataOne: function getProjectFieldInfoDataOne(val) {
      var _this12 = this;
      var params = {
        systemDeviceIds: val
      };
      (0, _dataQuery.getProjectFieldInfoEnergy)(params).then(function (res) {
        _this12.projectFieldInfoData = _this12.paramsSort(res, "fieldMeaning");
      });
    },
    getProjectSystemDeviceDataOne: function getProjectSystemDeviceDataOne(val) {
      var _this13 = this;
      var params = {
        projectSystemIds: val
      };
      (0, _dataQuery.getProjectEnergySystemDevice)(params).then(function (res) {
        _this13.projectSystemDeviceData = _this13.paramsSort(res, "systemDeviceName");
      });
    },
    getProjectSystemData: function () {
      var _getProjectSystemData = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var params, res;
        return _regenerator.default.wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              params = {
                projectId: this.$store.state.project.projectInfo.id
              };
              _context5.next = 3;
              return (0, _dataQuery.getProjectEnergySystem)(params);
            case 3:
              res = _context5.sent;
              this.projectSystemData = this.paramsSort(res, "projectSystemName");
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee3, this);
      }));
      function getProjectSystemData() {
        return _getProjectSystemData.apply(this, arguments);
      }
      return getProjectSystemData;
    }(),
    getHistoricalDatExportData: function getHistoricalDatExportData() {
      var _this14 = this;
      this.loading = true;
      this.form.timeType = this.energyForm.isShow;
      this.form.cycleType = this.energyForm.isTimeShow;
      setTimeout(function () {
        _this14.loading = false;
      }, 2000);
      (0, _dataQuery.getEnergyConsumptionQueryExport)(this.form).then(function (res) {
        _this14.loading = false;
        var link = document.createElement("a");
        link.href = res;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    handlQuery: function handlQuery() {
      if (this.form.projectFieldIds.length === 0) {
        this.$message.warning("请选择字段名称");
      } else if (this.energyForm.isShow == 0 && this.energyForm.isTimeShow != 3) {
        if (!this.startDate) {
          this.$message.warning("请选择开始日期");
        } else if (!this.endDate) {
          this.$message.warning("请选择结束日期");
        } else {
          this.getDataStatisticsData();
        }
      } else if (this.energyForm.isShow == 0 && this.energyForm.isTimeShow == 3) {
        if (!this.startDateMonth) {
          this.$message.warning("请选择开始月份");
        } else if (!this.endDateMonth) {
          this.$message.warning("请选择结束月份");
        } else {
          this.getDataStatisticsData();
        }
      } else {
        this.getDataStatisticsData();
      }
    },
    getLineCharts: function getLineCharts() {
      var _this15 = this;
      //
      var _this = this;
      var barCharts = this.$echarts.init(document.getElementById("bar-chart"));
      barCharts.clear();
      var historicalData = [];
      _this.historicalData.map(function (e, i) {
        historicalData.push({
          type: "bar",
          name: e.fieldMeaning,
          symbol: "circle",
          dimensions: [e.company // 如果此维度不想给出定义，则使用 null 即可
          ],
          // barWidth: 10,
          showSymbol: false,
          data: e.data
        });
      });
      var option = {
        tooltip: {
          confine: true,
          borderWidth: 0,
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#333333",
          textStyle: {
            fontSize: 14,
            lineHeight: 30
          },
          padding: 15,
          formatter: function formatter(params) {
            var str = "";
            str = params[0].name;
            params.map(function (el) {
              str = str + "<br/><span class=\"color-circle\" style=\"background:".concat(el.color, ";\"></span> ").concat(el.seriesName, " : ").concat(el.value[1], "  ").concat(el.dimensionNames[0] === "x" ? "" : el.dimensionNames[0]);
            });
            return str;
          }
        },
        color: this.colors,
        toolbox: {
          show: true,
          itemSize: 18,
          top: "6%",
          right: "7%",
          feature: {
            /* line是折线图，bar是柱形图*/
            magicType: {
              //动态类型切换
              show: true,
              //是否显示该工具
              type: ['line', 'bar'],
              //启用的动态类型
              title: {
                line: '切换为折线图',
                bar: '切换为柱状图'
              }
            }
            // myTool1: {
            //   show: true,
            //   title: '下载报表',
            //   icon: 'image://' + require('@/assets/icon/icon_down.png'),
            //   onclick: function() {
            //     _this.getHistoricalDatExportData()
            //   }
            // }
          },
          iconStyle: {
            //   color: '#7e7af6' // 设置颜色
          }
        },
        legend: {
          icon: "circle",
          top: "1%",
          bottom: "1%",
          width: "85%",
          type: "scroll",
          textStyle: {
            // label: { show: true },
            color: "#ffffff"
          }
        },
        grid: {
          left: "3%",
          right: "3%",
          top: "10%",
          bottom: "10%",
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        dataZoom: [{
          type: "slider",
          height: 20,
          handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
          handleSize: "100%",
          handleStyle: {
            borderColor: "#D2D0FF",
            shadowBlur: 4,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: "#e5e5e5"
          },
          show: true,
          // flase直接隐藏图形
          xAxisIndex: [0],
          left: "4%",
          // 滚动条靠左侧的百分比
          bottom: 15,
          start: 0,
          // 滚动条的起始位置
          end: 100 // 滚动条的截止位置（按比例分割你的柱状图x轴长度）,
        }],
        xAxis: {
          type: "category",
          boundaryGap: true,
          splitLine: {
            show: false
          },
          // 去除网格线
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: function formatter(params) {
              if (params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 10; // 一行显示几个字
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              }
            },
            textStyle: {
              color: "#999999" // 文字颜色
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#cfcfcf",
              width: 1,
              type: "solid"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#cfcfcf",
              width: 1,
              type: "solid"
            }
          },
          axisLabel: {
            textStyle: {
              color: "#999999" // 文字颜色
            }
          }
        },
        series: historicalData
      };
      barCharts.setOption(option);
      this.$nextTick(function () {
        _this15.zoom = document.body.style.zoom;
        _this15.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
      });
    }
  }
};